// extracted by mini-css-extract-plugin
export default {"scanBtn":"scanButton_scanBtn__qqIu9"};